import { RotateCcw } from 'lucide-react'
import {
  isRetryableError,
  reportErrorToSentry,
  showErrorToast
} from '@/shared/utils/handle-api-error'

/** Presents v2 Problem Details with the same rich, actionable toast used by the portal. */
export function showApiTokenError(error: unknown, retry?: () => void): void {
  showErrorToast(
    error,
    retry && isRetryableError(error)
      ? [{ label: 'Reintentar', onClick: retry, primary: true, icon: RotateCcw }]
      : []
  )
  reportErrorToSentry(error)
}
